<template>
    <div class="noMaskImage">
         <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>   
            <el-container>        
                <el-row :gutter="0">
                    <el-col :span="6" v-for="(item,index) in HospitalImgList" :key="index">
                        <div class="noMaskImageMain" @click="imgLinkUrl(item)">
                            <img :src="item.imgUrl" :alt="item.imgAlt">
                            <span>{{item.title}}</span>
                        </div>
                    </el-col>
                </el-row>
            </el-container>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        val: {}
    },
    data(){
        return{
            HospitalImgList:[],
        }
    },
    methods:{
        imgLinkUrl(data){
            if(data.linkUrl){
                window.open(data.linkUrl,'_self');
            }
        },
        patchData(){
            this.HospitalImgList = this.val.attaches;
        }
    },    
    created() {
        this.patchData()
    },
    watch: {
      val(val) {
        this.patchData()
      }
    }
}
</script>
<style lang="less" scoped>
.noMaskImage{
    width: 100%;
    .noMaskImageMain{
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        height: 125px;
        cursor: pointer;
        span{
            display: inline-block;
            background: rgba(0, 0, 0, .5);
            color: #fff;
            position: absolute;
            line-height: 24px;
            border-radius: 6px;
            width: 90px;
        }
        img{
            height: 100%;
            display: block;
        }
    }
    .noMaskImageMain:hover{
        img{
            transform: scale(1.2);          
            transition: all 3s;
        }
    }
    @media (min-width: 768px) and (max-width: 992px) { 
        .noMaskImageMain{
            height:160px;
        }    
    }
    @media (min-width: 992px) and (max-width: 1200px) { 
        .noMaskImageMain{
            height:180px;
        }    
    }
    @media only screen and (min-width: 1200px){
        .noMaskImageMain{
            height:240px;
        }
    }
    

}
</style>


// WEBPACK FOOTER //
// src/components/item/patch4.vue